const Staff = [
	{
		name: 'stafforganizations',
		path: '/staff/organizations',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/Organizations/OrgManagement.vue'),
		meta: {
			auth: true,
			title: 'Organization Management | Staff',
			permission: 'STAFF',
		},
	},
	{
		name: 'staffneworganizations',
		path: '/staff/organizations/new',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/Organizations/NewOrg.vue'),
		meta: {
			auth: true,
			title: 'New Organization | Staff',
			permission: 'STAFF',
		},
	},
	{
		name: 'stafforganizationtabbed',
		path: '/staff/organizations/:org_id/:tab?',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/Organizations/Single.vue'),
		meta: {
			auth: true,
			title: 'Organization | Staff',
			permission: 'STAFF',
		},
	},
	{
		name: 'staffaccounting',
		path: '/staff/accounting',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/Accounting/Accounting.vue'),
		meta: {
			auth: true,
			title: 'Accounting | Staff',
			permission: 'STAFF_ACCOUNTING',
		},
	},
	{
		name: 'staffrecurring',
		path: '/staff/recurring',
		component: () =>
			import(
				/* webpackChunkName: "Staff" */ '@/pages/Staff/Accounting/RecurringPayments.vue'
			),
		meta: {
			auth: true,
			title: 'Recurring Payments | Staff',
			permission: 'STAFF_ACCOUNTING',
		},
	},
	{
		name: 'staffenabledrecurring',
		path: '/staff/recurring/policies',
		component: () =>
			import(
				/* webpackChunkName: "Staff" */ '@/pages/Staff/Accounting/EnabledRecurringPayments.vue'
			),
		meta: {
			auth: true,
			title: 'Recurring Policies | Staff',
			permission: 'STAFF_ACCOUNTING',
		},
	},
	{
		name: 'staffclaims',
		path: '/staff/claims',
		component: () => import(/* webpackChunkName: "Staff" */ '@/pages/Staff/Claims/Claims.vue'),
		meta: {
			auth: true,
			title: 'Claims | Staff',
			permission: 'STAFF_CLAIMS',
		},
	},
	{
		name: 'staffoffbase',
		path: '/staff/offbase',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/Offbase/Offbase.vue'),
		meta: {
			auth: true,
			title: 'Offbase | Staff',
		},
	},
	{
		name: 'staffclaimssingle',
		path: '/staff/claims/:id',
		component: () => import(/* webpackChunkName: "Staff" */ '@/pages/Staff/Claims/Single.vue'),
		meta: {
			auth: true,
			title: 'Claims | Staff',
			permission: 'STAFF_CLAIMS',
		},
	},
	{
		name: 'staffoffbasedocument',
		path: '/staff/offbase/:id',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/Offbase/Document.vue'),
		meta: {
			auth: true,
			title: 'Offbase | Staff',
		},
	},
	{
		name: 'staffoffbasedocupload',
		path: '/staff/offbase/upload',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/Offbase/DocumentUpload.vue'),
		meta: {
			auth: true,
			title: 'Offbase | Staff',
		},
	},
	{
		name: 'staffusermanagement',
		path: '/staff/users',
		component: () =>
			import(
				/* webpackChunkName: "Staff" */ '@/pages/Staff/UserManagement/UserManagement.vue'
			),
		meta: {
			auth: true,
			title: 'User Management | Staff',
			permission: 'STAFF',
		},
	},
	{
		name: 'staffusermanagement',
		path: '/staff/users/incomplete',
		component: () =>
			import(
				/* webpackChunkName: "Staff" */ '@/pages/Staff/UserManagement/IncompleteUsers.vue'
			),
		meta: {
			auth: true,
			title: 'Incomplete Users | User Management | Staff',
			permission: 'STAFF',
		},
	},
	{
		name: 'staffusermanagementinvite',
		path: '/staff/users/invite',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/UserManagement/Invite2.vue'),
		meta: {
			auth: true,
			title: 'Invite User Management | Staff',
			permission: 'STAFF',
		},
	},
	{
		name: 'staffusermanagementinvitelist',
		path: '/staff/invites',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/UserManagement/InviteList.vue'),
		meta: {
			auth: true,
			title: 'User Invites Management | Staff',
			permission: 'STAFF',
		},
	},
	{
		name: 'staffusermanagementinvitesingle',
		path: '/staff/invites/:email',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/UserManagement/InviteSingle.vue'),
		meta: {
			auth: true,
			title: 'User Invites Management | Staff',
			permission: 'STAFF',
		},
	},
	{
		name: 'staffusermanagementsingle',
		path: '/staff/users/:user_id/:tab?',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/UserManagement/Single.vue'),
		meta: {
			auth: true,
			title: 'User Management | Staff',
			permission: 'STAFF',
		},
	},
	{
		name: 'staffapprovals',
		path: '/staff/approvals',
		component: () => import(/* webpackChunkName: "Staff" */ '@/pages/Staff/Approvals/List.vue'),
		meta: {
			auth: true,
			title: 'User Approvals| Staff',
			permission: 'STAFF',
		},
	},
	{
		name: 'staffmigration',
		path: '/staff/migrations',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/Migrations/Migrations.vue'),
		meta: {
			auth: true,
			title: 'User Migrations | Staff',
			permission: 'STAFF',
		},
	},
	{
		name: 'staffmigrationuser',
		path: '/staff/migrations/:accountId',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/Migrations/Single.vue'),
		meta: {
			auth: true,
			title: 'User Migrations | Staff',
			permission: 'STAFF',
		},
	},
	{
		name: 'staffpolicies',
		path: '/staff/policies',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/ManagePolicies/List.vue'),
		meta: {
			auth: true,
			title: 'Policy Management | Staff',
			permission: 'STAFF',
		},
	},
	{
		name: 'staffpolicy',
		path: '/staff/policies/:product_id/:tab?',
		component: () =>
			import(/* webpackChunkName: "Staff" */ '@/pages/Staff/ManagePolicies/Single.vue'),
		meta: {
			auth: true,
			title: 'Policy Management | Staff',
			permission: 'STAFF',
		},
	},
	{
		path: '/staff/cpsp',
		name: 'cpsp',
		component: () => import(/* webpackChunkName: "MMIC" */ '@/pages/Claims/Global/CPSP.vue'),
		meta: {
			title: 'Clinic Peer Support Requests',
			auth: true,
			permission: 'STAFF_CLAIMS',
		},
	},
	{
		path: '/staff/assigned-cpsp',
		name: 'cpsp',
		component: () => import(/* webpackChunkName: "MMIC" */ '@/pages/Claims/Global/ActiveCPSPRequests.vue'),
		meta: {
			title: 'Assigned Clinic Peer Support Requests',
			auth: true,
			permission: 'STAFF_CLAIMS',
		},
	},
	{
		path: '/staff/cpsp-invoices',
		name: 'cpsp-invoices',
		component: () => import(/* webpackChunkName: "MMIC" */ '@/pages/Claims/Global/CPSPInvoices.vue'),
		meta: {
			title: 'Clinic Peer Support Invoices',
			auth: true,
			permission: 'STAFF_CLAIMS',
		},
	},
	{
		path: '/staff/cpsp-request-form',
		name: 'cpsp-request-form',
		component: () =>
			import(/* webpackChunkName: "MMIC" */ '@/pages/Claims/Global/CPSPDetail.vue'),
		meta: {
			title: 'Clinic Peer Support Request Form',
			auth: true,
			permission: 'STAFF_CLAIMS',
		},
	},
];

export default Staff;
